// extracted by mini-css-extract-plugin
export default {"root":"iframePopup_root__pOGiA","iframe":"iframePopup_iframe__lV-LV","stripes-animation-background-keyframes":"iframePopup_stripes-animation-background-keyframes__QO00L"};